
    <pp-shell-dialog [title]="data.title | translate">
      <div mat-dialog-content>
        <p class="description">
          {{data.description | translate: ({servicePhoneNumber: data.servicePhoneNumber})}}
        </p>
      </div>
    </pp-shell-dialog>
  